import {ApplicationApi} from 'pwm-shared/dist';
import {API} from 'pwm-shared/src/types';
import {useAnalytics} from 'src/PWM/hooks/use-analytics';
import {useApi} from 'src/PWM/hooks/use-api';
import {useMemo} from 'react';

export const useAppSettingsApi = () => {
  const authenticatedApiClient = useApi();
  const {log} = useAnalytics();

  const client = authenticatedApiClient?.getClient();

  return useMemo(() => {
    if (!authenticatedApiClient) {
      log.error('Authenticated API unavailable');
      return undefined;
    }
    if (!client) return undefined;

    return {
      async getApplicationModules() {
        const {data} = await client.get<API.Response<InstanceType<typeof ApplicationApi.ApplicationModule>[]>>(
          `app/data`
        );
        return data.data;
      }
    };
  }, [authenticatedApiClient, client, log]);
};